import type { ApiCallConfig } from "../types"

export const API_SETUP_METHODS = ["GET", "POST", "PUT", "DELETE"] as const

export function isSupportedApiMethod(method: string | undefined): boolean {
  return API_SETUP_METHODS.some(
    (supported) => supported === (method || "GET").toUpperCase(),
  )
}

export function getApiCallValidationIssues(
  call: ApiCallConfig | undefined,
): string[] {
  if (!call) {
    return []
  }
  const issues: string[] = []
  try {
    const url = new URL(call.api_url)
    if (!["http:", "https:"].includes(url.protocol)) {
      issues.push("Enter an HTTP or HTTPS API URL.")
    }
  } catch {
    issues.push("Enter a complete API URL.")
  }
  if (!isSupportedApiMethod(call.method)) {
    issues.push("Choose GET, POST, PUT or DELETE.")
  }
  if (
    call.timeout !== undefined &&
    (!Number.isFinite(call.timeout) || call.timeout <= 0)
  ) {
    issues.push("Enter a timeout greater than zero.")
  }
  for (const [label, value] of [
    ["Request body", call.request_body],
    ["Headers", call.headers],
  ] as const) {
    if (typeof value === "string") {
      try {
        JSON.parse(value)
      } catch {
        issues.push(`${label} must contain valid JSON.`)
      }
    }
  }
  return issues
}
